export enum PPFolderAndFilesActionsEnum {
    View = 1,
    Delete
}

export enum PPFolderAndFilesNotificationEnum {
    notRequired = 1,
    requiredNotSent,
    requiredSent
}

export enum PPNotificationStatusEnum {
    notRequired = 'NotRequired', 
    requiredNotSent = 'RequiredNotSent', 
    requiredSent = 'RequiredSent'
} 

export enum PPApprovalStatusEnum {
    pending = 'Pending', 
    approved = 'Approved', 
    rejected = 'Rejected',
    doesntApply = 'DoesntApply'
}

export enum PPFolderReturnToEnum {
    home = 'home',
    parent = 'parent'
}
